import { LegacySdkRefPage } from '@squareup/dex-feature-dex-tech-docs-legacy-sdk-ref';

const Page = () => {
  return <LegacySdkRefPage platform="in_app_payment_ios" />;
};

export default Page;
